import React, { useEffect, useState } from "react";
import api from "../lib/api";
import GateScreen from "./GateScreen";

export default function GateGuard({ children }) {
  const [status, setStatus] = useState("checking"); // checking | locked | open

  useEffect(() => {
    const token = localStorage.getItem("gate_token");
    if (!token) {
      setStatus("locked");
      return;
    }
    api.get("/auth/gate/status")
      .then((res) => {
        if (res.data.valid) {
          setStatus("open");
        } else {
          localStorage.removeItem("gate_token");
          setStatus("locked");
        }
      })
      .catch(() => setStatus("locked"));
  }, []);

  if (status === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-950" data-testid="gate-checking">
        <div className="text-zinc-500 text-sm tracking-widest uppercase animate-pulse">Memverifikasi akses…</div>
      </div>
    );
  }

  if (status === "locked") {
    return <GateScreen onUnlock={() => setStatus("open")} />;
  }

  return children;
}
